function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.1464 1.5715c-.8699 0-1.575.7052-1.575 1.575V9.184c0 .8699.7051 1.575 1.575 1.575h7.6125V3.1465c0-.8698-.7053-1.575-1.575-1.575H3.1464zm0 11.8126c-.8699 0-1.575.7051-1.575 1.575v6.0374c0 .87.7051 1.575 1.575 1.575h6.0375c.8697 0 1.575-.705 1.575-1.575v-7.6124H3.1464zM13.3838 3.1465c0-.8698.7051-1.575 1.575-1.575h6.0376c.8697 0 1.575.7052 1.575 1.575V9.184c0 .8699-.7053 1.575-1.575 1.575h-7.6126V3.1465zm7.6126 10.2376h-7.6126v7.6124c0 .87.7051 1.575 1.575 1.575h6.0376c.8697 0 1.575-.705 1.575-1.575v-6.0374c0-.8699-.7053-1.575-1.575-1.575z"
});

function SvgTile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#037BFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.87feca18.svg";
export { ForwardRef as ReactComponent };